module.exports = {"name":"jwplayer","type":"adapter","tech":"js","author":"Jesus Lopez","version":"6.2.1","built":"2018-04-17","repo":"https://bitbucket.org/npaw/jwplayer-adapter-js","libVersion":"6.2.0","features":{"buffer":"monitor","seek":"native","getters":["getPlayhead","getPlayrate","getDuration","getBitrate","getRendition","getTitle","getIsLive","getResource","getPosition"]},"ads":[{"buffer":"monitor","seek":"monitor","getters":["getPlayhead","getDuration","getTitle","getResource","getPosition"],"filename":"native.js"}]}


//////////////////
// WEBPACK FOOTER
// ./manifest.json
// module id = 15
// module chunks = 0